import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/ButtonGroup": ButtonGroup, "@mui/material/Button": Button } } });
export default ClientProvider;
